import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { PartnerStore } from '@app/config/partner-store';
import { config } from '@app/config/app';

@Component({
  selector: 'app-admin-redirect',
  standalone: true,
  imports: [],
  templateUrl: './admin-redirect.component.html',
  styleUrl: './admin-redirect.component.css',
})
export class AdminRedirectComponent {
  pathName: string = '';

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private store: PartnerStore,
  ) {
    this.pathName = this.document.location.pathname;
    this.redirect();
  }

  async redirect() {
    if (config.env === 'prod' && (this.pathName === '/' || this.pathName === '')) {
      const baseURL = `${this.document.location.protocol}//${this.document.location.host}`;
      this.document.location.href = `${baseURL}/content/`;
      return;
    }

    if (!this.store.partnerAuth()) {
      this.router.navigate(['/partner/login']);
      return;
    }

    // TODO: implement default routes
    this.router.navigate(['/partner/dashboard/organizations']);
  }
}
